module.exports = __webpack_public_path__ + "img/cooperation_unit_12.81c2a8fb.png";